/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notes_V2_Filter_PlaceholderInputs */

const en_notes_v2_filter_placeholder = /** @type {(inputs: Notes_V2_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter notes…`)
};

const es_notes_v2_filter_placeholder = /** @type {(inputs: Notes_V2_Filter_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar notas…`)
};

/**
* | output |
* | --- |
* | "Filter notes…" |
*
* @param {Notes_V2_Filter_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const notes_v2_filter_placeholder = /** @type {((inputs?: Notes_V2_Filter_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notes_V2_Filter_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_notes_v2_filter_placeholder(inputs)
	return en_notes_v2_filter_placeholder(inputs)
});